<template>
  <div class="app-loading">
    <div ref="lottieIcon" class="lottie-icon"></div>
  </div>
</template>
<script>
import lottie from 'lottie-web'
export default {
  data() {
    return {}
  },
  mounted() {
    this.lottie = lottie.loadAnimation({
      container: this.$refs.lottieIcon, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: 'https://gymvue.gymcity.com.cn/betterwe_app/loading02.json' // the path to the animation json
    })
  },
  methods: {}
}
</script>
<style scoped lang="scss">
.lottie-icon {
  width: 40px;
  height: 40px;
}
</style>
